import classNames from 'classnames';
import React from 'react';
import Icon from '@material-ui/core/Icon';
import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@material-ui/core';

export interface TooltipProps extends MuiTooltipProps {
  className?: string;
}

/**
 * Tooltip
 * see https://material-ui.com/components/tooltips
 */
class Tooltip extends React.Component<TooltipProps, {}> {
  constructor(props: TooltipProps) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { children, title, ...props } = this.props;

    return (
      <MuiTooltip
        title={<div className='tooltip uc-tooltip-popover uc-tooltip-popover--large uc-tooltip-popover--open'>{title}</div>}
        {...props}>
        {children}
      </MuiTooltip>
    );
  }
}

export default Tooltip;
